import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
    CommerceConfigurationsRouting, ManualSynchronizationRouting
} from './app.consts';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: CommerceConfigurationsRouting.Root,
    loadChildren: () =>
      import(
        './commerce-configurations/commerce-configurations.module'
      ).then((m) => m.CommerceConfigurationsModule),
    runGuardsAndResolvers: 'always',
  },
  {
    path: ManualSynchronizationRouting.Root,
    loadChildren: () =>
      import('./manual-synchronization/manual-synchronization.module').then(
        (m) => m.ManualSynchronizationModule
      ),
  },
  // just as a safty measure. when moving to this state we will log it using status.
  {
    path: '**',
    component: PageNotFoundComponent,
    runGuardsAndResolvers: 'always',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload', // needed so if the user refreshes the page we reload the whole app. it's an easier app state handling.
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
